<div class="workflow-card -card">
  <div class="workflow-card -status d-flex align-items-stretch">
    @if (!isApiPage) {
    <div>
      <icon [icon]="iconProperties.iconPath" [ngClass]="iconProperties.className"> </icon>
    </div>
    } @if (isApiPage) {
    <div [ngClass]="_childrenCollapsedState.closed ? '-card-number-collapsed' : '-card-number-expanded'">
      <span class="-card-no">{{ card }}</span>
    </div>
    } @if (order === 'last' ? false : true) {
    <div
      [ngClass]="
        isApiPage && _childrenCollapsedState.closed && !card
          ? 'workflow-card -spacer-collapsed'
          : 'workflow-card -spacer'
      "></div>
    }
  </div>
  <div
    [ngClass]="bottomCardPadding ? 'workflow-card -content -bottom-padding' : 'workflow-card -content'"
    class="workflow-card -content">
    <span class="workflow-card -content-title">
      {{ title }}
      &nbsp; @if (tasksComplete > -1) {
      <span class="workflow-card -content-subtitle"> ({{ tasksComplete }} of {{ taskCount }} complete) </span>
      } @else {
      <span class="-fontXSmall">
        {{ taskCount }}
      </span>
      }
    </span>
    <p class="-fontSmall workflow-card" [ngClass]="isApiPage ? '-content-description-width' : '-content-description'">
      {{ description }}
    </p>

    <div [hidden]="nocontent">
      <div #childrenContainer class="workflow-card -childrenContainer" [@_closed]="_childrenCollapsedState.closed">
        <ng-content></ng-content>
      </div>
    </div>
    <link-icon
      iconclass="-sm -colorPrimaryGreen"
      class="workflow-card -link-icon -toggle"
      (click)="changeExpandState()"
      [icon]="_childrenCollapsedState.iconPath">
      {{ _childrenCollapsedState.label }}
    </link-icon>
  </div>
</div>